import React from 'react';

import { FileInfo } from '@uploadcare/react-widget';
import EditIcon from '@zola/zola-ui/src/components/SvgIcons/EditIcon';

import openUploadcareModal from '@zola-helpers/client/dist/es/uploadcare/openUploadcareModal';
import type { UploadcareModalProps } from '@zola-helpers/client/dist/es/uploadcare/openUploadcareModal';

import { useAppDispatch } from 'reducers/index';

import { saveUploadcareImageToZola } from 'actions/UploadcareActions';
import { ZolaFileResponseType } from 'actions/types/UploadcareActions';

import { StyledBtn } from './EditPhotoUploadcare.styles';
import './EditPhotoUploadcare.module.less';

type EditPhotoUploadcareProps = Omit<UploadcareModalProps, 'onUploadcareFileReady'> & {
  className?: string;
  onUploadComplete: (zolaFile: ZolaFileResponseType) => void;
  styleId?: string;
};

const EditPhotoUploadcare: React.FC<EditPhotoUploadcareProps> = ({
  className,
  onUploadComplete,
  styleId = 'EditPhotoUploadcare',
  ...UploadcareModalOptions
}) => {
  const dispatch = useAppDispatch();

  function openUploadcare() {
    const handleOnFileReady = (uploadcareFile: FileInfo) => {
      dispatch(saveUploadcareImageToZola(uploadcareFile)).then((zolaFile: ZolaFileResponseType) => {
        onUploadComplete(zolaFile);
      });
    };
    openUploadcareModal({
      effects: 'mirror,enhance,sharp,blur,grayscale,crop',
      styleId,
      ...UploadcareModalOptions,
      onUploadcareFileReady: file => {
        if (file && typeof file !== 'string') {
          handleOnFileReady(file);
        }
      },
    });
  }

  return (
    <div className={className}>
      <StyledBtn type="button" onClick={openUploadcare}>
        <EditIcon />
        <span>Edit photo</span>
      </StyledBtn>
    </div>
  );
};

export default EditPhotoUploadcare;
